export default {
  groupName: 'ford-ap',
  appName: 'Ford Asia Pacific',
  isAuto: true,
  image: 'ford.png',
  baseRoute: '/ford-ap',
  description:
  "Ford - Asia Pacific Advertising Dashboard (Starting Apr 2019)"
}
